import { render, staticRenderFns } from "./footerFundacion.vue?vue&type=template&id=d323e830&"
import script from "./footerFundacion.vue?vue&type=script&lang=js&"
export * from "./footerFundacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports